// import * as Stitches from '@stitches/react';
import { styled } from '@gbm-tech/styles';

export const DatePickerContainer = styled('button', {
  width: '100%',
  height: '48px',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  fontSize: '1.8rem',

  fontWeight: '400',
  textAlign: 'center',
  color: '$gray700',

  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  borderRadius: '4px',
  border: '1px solid #dae0e7',
  backgroundColor: '$white',

  span: {
    width: '170px',
    padding: '1rem 2rem',
    color: '$lightText',

    textTransform: 'capitalize',

    '&.false': {
      marginLeft: '-8px',
    },
  },

  '.calendar': {
    height: '100%',

    padding: '1.3rem 1.4rem',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    backgroundColor: '$white',

    '> svg': {
      fontSize: '2rem',
      color: '$lightText',
    },
  },
});

export const DatePickerStyle = styled('div', {
  '.react-datepicker__aria-live': {
    display: 'none',
  },

  '.react-datepicker-popper': {
    zIndex: 9999,
  },

  '.react-datepicker-wrapper': {
    width: 'auto',
  },

  '.react-datepicker__month-container': {
    width: '200px'
  },

  '.react-datepicker': {
    fontSize: '1.28rem',
  },

  '.react-datepicker__current-month': {
    fontSize: '1.5rem',
    color: '#404A59',
    fontWeight: '500',
    paddingBottom: '0.6rem',
  },

  '.react-datepicker-year-header': {
    fontSize: '1.5rem',
    fontWeight: 'normal',
    color: '$lightText',
  },

  '.react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name':
    {
      width: '2.72rem',
      lineHeight: '2.72rem',
      margin: '0.265rem',
    },

  '.react-datepicker__month': {
    margin: '0.64rem',
  },

  '.react-datepicker__month-text': {
    padding: '1rem',
    width: '5rem',
    margin: '0',

    textAlign: 'center',
  },

  '.react-datepicker__month-text--keyboard-selected': {
    backgroundColor: '$gbmSky',
    color: '$white',
  },

  '.react-datepicker__navigation': {
    padding: '2.2rem 0',
    color: '$lightText',
  },

  '.react-datepicker__header': {
    background: '$lightHeader',
  },

  '.react-datepicker__day--outside-month': {
    opacity: '0.5',
  },

  '.react-datepicker__month-wrapper': {
    display: "flex",
    justifyContent: 'space-around'
  },

  '.react-datepicker-time__header': {
    fontSize: '1.5rem',
  },

  '.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .  react-datepicker__quarter-text--in-range, .  react-datepicker__year-text--selected, .             react-datepicker__year-text--in-selecting-range,                                  .react-datepicker__year-text--in-range, .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected':
    {
      backgroundColor: '#094fb8',
      color: '#f4f5f6',
    },

  '.react-datepicker__close-icon': {
    right: '48px',
    height: '48px',
    width: '48px',
    padding: '0',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0',

    '&:after': {
      height: '100%',
      width: '100%',
      padding: '0',
      borderRadius: '0',

      opacity: '0',
    },

    '&:before': {
      content: 'X',
      position: 'absolute',
      right: '0',
      top: '0',
      height: '100%',
      width: '100%',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      fontSize: '2rem',
      fontWeight: '500',
      color: '$gray800',

      backgroundColor: '$gray200',
      borderRight: '1px solid #bfc2c6',
    },
  },
});
